module.exports = __webpack_public_path__ + "media/images/flags/32/Bosnia-and-Herzegovina-cd67158d72215c31df0aa3df3392fbf6.png";